import React, { useState } from "react";
import { CampaignType } from "pages/dealScreener/Email/constants";

import { EditCampaignNameModal } from "../../dashboard/components";
import {
  EdcIndividualFilterBar,
  EdcIndividualContactsTable,
  EdcConfirmationModal,
  SendNowConfirmationModalConfig
} from "..";
import { PreviewBase } from "../../templates/PreviewBase";

const ReviewAndSend = ({
  setSearch: handleSetSearch,
  filterCompany,
  setFilterCompany: handleSetFilterCompany,
  filterCompanies,
  campaignConfig,
  rows,
  toggleElement,
  editedCampaignName,
  setEditedCampaignName,
  editCampaignNameModalIsOpen,
  onCancelClicked: handleOnCancelClicked,
  onSaveClicked: handleOnSaveClicked,
  getPrepayment,
  getValuationSensitivity,
  company,
  campaignType,
  canAddOrRemoveDeals,
  resetEmailCampaignPrepayment,
  resetEmailCampaignValuationSensitivity
}) => {
  const [showPreview, setShowPreview] = useState(false);
  const [showSendNow, setShowSendNow] = useState(false);
  const [dealId, setDealId] = useState(null);
  const [fetchCampaignFunction, setFetchCampaignFunction] = useState(() => () => undefined);

  const isPrepaymentCampaign = campaignType === CampaignType.PREPAYMENT.id;
  const isValuationSensitivityCampaign = campaignType === CampaignType.VALUATION_SENSITIVITY.id;

  const handleToggleShowSendNow = () => setShowSendNow(!showSendNow);

  const openAnalysis = id => {
    if (isValuationSensitivityCampaign) {
      setFetchCampaignFunction(() => () => getValuationSensitivity({ dealId: id }));
    }

    if (isPrepaymentCampaign) {
      setFetchCampaignFunction(() => () => getPrepayment({ dealId: id }));
    }

    setShowPreview(true);
    setDealId(id);
  };

  const handleCloseAnalysis = () => {
    isValuationSensitivityCampaign ? resetEmailCampaignValuationSensitivity() : resetEmailCampaignPrepayment();
    setShowPreview(false);
  };

  return (
    <>
      <EdcConfirmationModal
        show={showSendNow}
        onClose={handleToggleShowSendNow}
        config={SendNowConfirmationModalConfig}
      />
      <EdcIndividualFilterBar
        searchText="Search deals by name"
        onSearchTextUpdate={handleSetSearch}
        selectedFilterCompany={filterCompany}
        onUpdateFilterCompany={handleSetFilterCompany}
        companies={filterCompanies}
        onSendNowClicked={handleToggleShowSendNow}
      />
      <EdcIndividualContactsTable
        headers={campaignConfig?.headers}
        rows={rows}
        toggleElement={toggleElement}
        openAnalysis={openAnalysis}
        canAddOrRemoveDeals={canAddOrRemoveDeals}
      />
      {editCampaignNameModalIsOpen &&
        <EditCampaignNameModal
          editedCampaignName={editedCampaignName}
          setEditedCampaignName={setEditedCampaignName}
          isOpen={editCampaignNameModalIsOpen}
          onCancelClicked={handleOnCancelClicked}
          onSaveClicked={handleOnSaveClicked}
        />}

      {(showPreview) &&
        <PreviewBase
          logo={company.logoImage}
          campaignType={campaignType}
          fetchData={fetchCampaignFunction}
          open={showPreview}
          dealId={dealId}
          handleClose={handleCloseAnalysis}
        />}
    </>
  );
};

export default ReviewAndSend;
